export interface AccountingLinkedCheckProps {
  remittanceId: number;
  checkNumber: string;
  checkDate: string;
  checkAmount: number;
}

export class AccountingLinkedCheck implements AccountingLinkedCheckProps {
  private readonly _remittanceId: number;
  private readonly _checkNumber: string;
  private readonly _checkDate: string;
  private readonly _checkAmount: number;

  constructor(props: AccountingLinkedCheckProps) {
    this._remittanceId = props.remittanceId;
    this._checkNumber = props.checkNumber;
    this._checkDate = props.checkDate;
    this._checkAmount = Number(props.checkAmount);
  }

  public get remittanceId(): number {
    return this._remittanceId;
  }

  public get checkNumber(): string {
    return this._checkNumber;
  }

  public get checkDate(): string {
    return this._checkDate;
  }

  public get checkAmount(): number {
    return this._checkAmount;
  }

  public static fromJson(props: AccountingLinkedCheckProps): AccountingLinkedCheck {
    return new AccountingLinkedCheck(props);
  }
}
